import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: 8
    },
    button: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #ECECEC',
        borderRadius: 12,
        padding: 8,
        '& svg': {
            width: 16,
            height: 16
        }
    },
    menuList: {
        padding: 8
    },
    menuItem: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        fontWeight: 500,
        fontSize: 13,
        lineHeight: '150%',
        color: '#232323',
        padding: '12px 16px',
        borderRadius: 8
    },
    _minor: {
        color: '#8E8E8E'
    }
});
